<template>
<div class="container-fluid" >

<modal-spinner v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>  
<modal-market-promo @close="getData()" :key="refresh" v-bind:items="filteredItems" v-bind:mpId="mpId"></modal-market-promo>

 <div class="card border-success" >

  <div class="card-header text-white bg-primary">
    <h4><i style="color: yellow" class="fas fa-pen-square mr-2" aria-hidden="true"></i>
    PROMO PRODOTTI MARKET 
    <span class="ml-3" style="color:yellow"><strong class="mp">{{market}}</strong></span>
    </h4>
   
  </div> 

<div  class="card-body">   
<div class="row">
<div v-if="items.length==0" class="col-md-4"> 

  <div  class="card border-info" >
  <div class="card-header  bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">

  <form name="movementSearch" v-on:submit.prevent="submit()">
    
    <label>
      <strong>MARKET</strong>
    </label>
    <select @change="setMP($event)" required class="form-control mb-1" v-model="mpId" >
      <option v-for="(item,index) in marketList" :value="item.MarketPlaceId" :key="index">{{item.MarketPlace}}</option>        
    </select>


  <!-- <brand-list v-bind:props="brand" @update="setBrandId"></brand-list>-->
  

     <v-select-brand class="mb-2"
      v-model="selectedBrands"      
      label="BRAND"
      :required="true"
    />


    <season-select v-bind:props="season"  @update="setSeasonId"></season-select>
    <year-select  v-bind:props="season_year" @update="setYear"></year-select>
    <department-select v-bind:props="department" @update="setDepartmentId"></department-select>
        
    <div class="card-footer bg-transparent border-info"> 

      <alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
      
        <button :disabled="spinner" type="submit"  class="btn btn-primary float-right">
          <i class="far fa-play-circle mr-2"></i>
          ESEGUI
          <span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
        </button>         
    </div>

  </form>
  

  </div>
</div>

    <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre>{{ selectedBrands }}</pre> 
      
    </div>


</div>


<div v-else class="col">
  <div class="mb-1">
    
  <button  @click="items=[],msg.title=''" type="button"  class="btn btn-secondary mr-4 ml-1 ">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A RICERCA PRODOTTI
  </button> 

  

<button v-if="filteredItems.length > 0" @click="setModalPromo()"  type="button"  class="btn btn-primary ml-3 ">
            <i style="color: yellow;" class="fas fa-edit mr-2" aria-hidden="true"></i>
            REGISTRA PROMO PRODOTTI 
            <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>  




</div>  


<div class="row">
<div class="col">

<div class="table-wrapper-scroll-y my-custom-scrollbar">
<table class="table table-hover table-sm table-bordered table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">#</th>
        <th scope="col"></th>
        
       
        <th scope="col">ID PRODOTTO</th>
        <th scope="col">STAGIONE</th>
        <th scope="col">BRAND</th>
        <th scope="col">LINEA</th>
        <th scope="col">CODICE</th> 
        <th scope="col">GRUPPO</th> 
        <th scope="col">CATEGORIA</th>
        <th scope="col">DESCRIZIONE</th>
        
        <th scope="col">REPARTO</th>
       
        <th class="text-right" scope="col">LISTINO</th>        
        <th class="text-right" scope="col">% PROMO</th>        
      </tr>
    </thead>
    <tbody>
      
      <tr  class="pointer"   v-for="(item, index) in filteredItems" :key="index">
        <td>{{index+1}}</td>
        <td> <i @click="setImg(item.img)" class="fas fa-camera" aria-hidden="true"></i></td>
       
        
        <td>{{item.productId}}</td>
        <td>{{item.season}}</td>

        <td class="text-nowrap">{{item.brand}}</td>
        <td class="text-nowrap">{{item.line}}</td>
        <td class="text-nowrap">{{item.sku}}</td> 
        <td>{{ item.grpCategory }}</td>       
        <td>{{item.category}}</td>
        <td class="text-nowrap">{{item.description}}</td>
        
        <td>{{item.department}}</td>
        <!--<td class="text-nowrap">{{item.season}}-{{item.season_year}} </td>-->      
        <td class="text-right">{{fmt1(item.priceList)}}</td>
        <td class="text-right">{{item.promo}}</td>
              
      </tr> 
      
      
    </tbody>
 
  </table>
  
</div>


  

<label for="cerca"><strong>
  <i  class="fas fa-filter mr-2" aria-hidden="true"></i>
    Filtra</strong></label>
<input class="form-control mb-3" type="text" name="query" v-model="filterKey">

<alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>




</div>


</div>
</div>

<img-zoom v-if="img" @close="closeImg()" v-bind:img='img'></img-zoom>

</div>
</div>
</div>

   



</div>

</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';



import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'


import departmentSelect  from '@/components/common/DepartmentSelect_1.vue';


import imgZoom           from '@/components/common/ProductImg.vue'

import modalSpinner      from '@/components/common/ModalSpinner.vue'
import modalMarketPromo  from '@/components/admin/MarketPromoModal.vue'
import fmt               from '@/components/mixins/fmt.js'
import vSelectBrand      from './vSelectBrand.vue'

export default {
  components: {alertBox,seasonSelect,yearSelect,imgZoom,departmentSelect,modalSpinner,modalMarketPromo,vSelectBrand},
  mixins:[fmt],
  data() {
    return {
      selectedBrands  : [],
      modalSpinner    : {spinner:false,show:false},
      market          : '',
      index           : 0,
      mpId            : 0,
      marketList      : [], 
     
     
      filterKey       : '',
     
      
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        type          : true


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
       
      },

      spinner         : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
    
      items           : [], 
      img             : '',
            
      progress        : 0,
      
      refresh         : 0
          
    };
  },

  computed :{
    ...mapGetters(['company']),
     
    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },

     
    
  
  },
  
  
  mounted: function() {},
  created: function() {

   this.getMarketPlaceList()
  },
  methods: 
  {
    setModalPromo()
    {
      $('#MarketPromoModal').modal('show')
    },
    setModalSpinner(show)
    {
      

      this.modalSpinner.show = show
      
    },

    
    setMP(e)
    {
      this.market = e.target.options[e.target.options.selectedIndex].text      
    },

  
    async getMarketPlaceList()
    {
      var sp    = {'sp':'spCompanyMarketPlace'}
      var data  = {'companyId' : this.company.Id}
     
      var json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.marketList =  res.data.recordsets[0]         
          }
          else if(res.status==500)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        //this.spinner = false
      });

    },
    
    setAltImg(event) 
    { 
        event.target.src = require("@/assets/no_img.jpg")
    },         
 
    setImg(img)
    {
        this.img = img
    },
    closeImg()
    {
        this.img = ''
    },
    

  
  
    setSeasonId(seasonId)
    {   
        
        this.season.Id = seasonId
    },  
    setYear(year)
    {
        this.season_year.year = year
    },
       setDepartmentId(departmentId)
    {
      this.department.Id = departmentId
    },
    submit() 
    {
      this.getData()
      
    },  
    
    
    
    async getData() {
      
     
      this.items  = []
        
      this.msg.title = ''
      const sp = {'sp' : 'spMarketPromoProducts'}
      //const sp = {'sp' : 'spMarketPromoProductNew'}
      

      const data  = 
      {
        'companyId'   : this.company.Id,

        //'brand'       : this.brand.Id == 'TUTTI I BRAND' ? '%' : this.brand.Id,
        'brand'       : this.selectedBrands,
        'seasonId'    : this.season.Id,
        'departmentId': this.department.Id,
        'year'        : this.season_year.year,
        'mpId'        : this.mpId
      }
      
      

      const json  = Object.assign(data, sp)      
      
      this.spinner = true

      await api.post(json).then(async res => {
         
          if(res.status==200)
            {
              
              
              this.items = res.data.recordsets[0]  
              
              

                
              if(this.items.length==0)
              {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      

    },


  }

}
</script>
<style scoped>

.my-custom-scrollbar {
  position   : relative;
  height     : 600px;
  overflow   : auto;
}
.brandList {
  position  : relative;
  height    : 400px;
  overflow  : auto;
}
.brandItems {
  position  : relative;
  height    : 500px;
  overflow  : auto;
}
.pointer:hover
{
  _background-color: white;
  
  cursor: pointer;
}


.products tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }



 .table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 24px;
    background   : whitesmoke;
    color        : darkgreen;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 } 



.table-wrapper-scroll-y {
display: block;
}




h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}


div.catalog {
 
  height: 500px;
  _width: 200px;
  overflow-y: scroll;
}
.dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
.mp 
{
  font-family  : 'Roboto Condensed' !important;
  font-size    : 28px !important;
}

</style>